import { filter } from 'lodash';
import React from 'react';
import ReactSelect from 'react-select';
import PropTypes from 'prop-types';

import styles from './VendorSelector.module.css';
import makeVendorOption from '../../../Lib/Utils/Select/make-vendor-option';

/**
 * Formats the vendors that come back from the
 * search as valid options for the select component
 *
 * @param vendors - array of vendor objects.
 *
 * @returns {array} - array of objects with a
 * label and value property
 */
const formatVendorOptions = (vendors) => vendors.map(makeVendorOption);

const customStyles = {
  option: (provided, { isSelected, isFocused }) => ({
    ...provided,
    backgroundColor: isSelected || isFocused ? 'black' : 'white',
    color: isSelected || isFocused ? 'white' : 'black',
    ':active': 'black',
    lineHeight: '22px',
    fontSize: '14px',
    letterSpacing: '1px',
  }),
};

function VendorSelector(props) {
  const {
    approvedOnly = false,
    searchVendors,
    vendors,
    placeholder = 'Select Vendor',
  } = props;

  return (
    <ReactSelect
      className={styles.root}
      onInputChange={searchVendors}
      options={formatVendorOptions(
        filter(vendors, (v) => (approvedOnly ? v.internal_id : true)),
      )}
      placeholder={placeholder}
      {...props}
      styles={customStyles}
      theme={(theme) => ({
        ...theme,
        borderRadius: 0,
        colors: {
          ...theme.colors,
          primary: 'black',
        },
      })}
    />
  );
}

VendorSelector.propTypes = {
  approvedOnly: PropTypes.bool,
  searchVendors: PropTypes.func.isRequired,
  vendors: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  placeholder: PropTypes.string,
};

export default VendorSelector;
